import React from "react";
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardHeader,
  HStack,
  Heading,
  Select,
  SkeletonText,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import EmptyState from "./EmptyState";

const ReportSubscriptionsPanel = ({
  subscriptions,
  isLoading,
  statusOptions,
  statusFilter,
  onStatusChange,
  onPrint,
  formatCurrency,
  formatDateTime,
  statusColor,
}) => {
  return (
    <Card variant="outline" _hover={{ boxShadow: "md" }} transition="box-shadow 0.2s ease">
      <CardHeader>
        <HStack justify="space-between" flexWrap="wrap" gap={3}>
          <Heading size="sm">All Subscriptions</Heading>
          <HStack spacing={3}>
            <Select
              size="sm"
              value={statusFilter}
              onChange={(event) => onStatusChange(event.target.value)}
            >
              <option value="all">All statuses</option>
              {statusOptions.map((status) => (
                <option key={status} value={status}>
                  {status}
                </option>
              ))}
            </Select>
            <Button size="sm" variant="outline" onClick={onPrint}>
              Print PDF
            </Button>
            <Text fontSize="sm" color="gray.500">
              {subscriptions.length} records
            </Text>
          </HStack>
        </HStack>
      </CardHeader>
      <CardBody>
        {isLoading ? (
          <SkeletonText noOfLines={6} spacing="3" />
        ) : subscriptions.length === 0 ? (
          <EmptyState title="No subscriptions" description="No subscriptions match the selected filters." />
        ) : (
          <TableContainer>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Customer</Th>
                  <Th>Plan</Th>
                  <Th isNumeric>Amount</Th>
                  <Th>Status</Th>
                  <Th>Period End</Th>
                  <Th>Created</Th>
                </Tr>
              </Thead>
              <Tbody>
                {subscriptions.map((subscription) => (
                  <Tr key={subscription.id}>
                    <Td>{subscription.customer?.email}</Td>
                    <Td>{subscription.plan?.name}</Td>
                    <Td isNumeric>
                      {formatCurrency(subscription.plan?.amount, subscription.plan?.currency)}
                    </Td>
                    <Td>
                      <Badge colorScheme={statusColor(subscription.status)}>{subscription.status}</Badge>
                    </Td>
                    <Td>{formatDateTime(subscription.currentPeriodEnd)}</Td>
                    <Td>{formatDateTime(subscription.createdAt)}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </CardBody>
    </Card>
  );
};

export default ReportSubscriptionsPanel;
